import React, { useState, useEffect } from 'react'
import { Formik, Form } from 'formik'
import { FaCheck } from 'react-icons/fa'
import { getYear } from 'date-fns'

import Yup from '~/services/yup'
import { api } from '~/services/api'

import maskUtils from '~/util/masks'

import ActionFooter from '~/components/ActionFooter'
import Modal from '~/components/Modal'
import { Button, Checkbox } from '~/components/Form'

import { Container, TermoContainer, ModalTermoContainer } from './styles'
import { calculaAnuidadeProporcional } from '~/util/valorAnuidade'
import Spinner from '~/components/Spinner'

const initialValues = {
    autorizado: false
}

const validation = Yup.object({
    autorizado: Yup.boolean()
})

export default function ({ onSubmit }) {
    const [valoresAnuidade, setValoresAnuidade] = useState([])
    const [showTermoCiencia, setShowTermoCiencia] = useState(false)
    const [valorAspirante, setValorAspirante] = useState(null)
    const [ano, setAno] = useState(new Date().getFullYear())

    useEffect(() => {
        async function loadValores() {
            const response = await api.get('desconto_anuidade')

            const mensalidade = await api.get(`mensalidade_valor/${new Date().getFullYear()}`)

            if (new Date() > new Date(getYear(new Date()), 5, 30)) {
                const { valorAnuidadeProporcional, competenciaAno } = await calculaAnuidadeProporcional(mensalidade.valor)
                setValoresAnuidade([{ valor: valorAnuidadeProporcional }])
                setAno(competenciaAno)
            } else {
                const valores = response.filter(valor => new Date() >= new Date(valor.inicio_desconto) && new Date() <= new Date(valor.fim_desconto))
                if (valores.length > 0) {
                    setValoresAnuidade(valores)
                } else {
                    let valorAnuidade = mensalidade.valor * 12

                    if (getYear(new Date()) === 2026) {
                        valorAnuidade += 0.10
                    }
                    setValoresAnuidade([{ valor: valorAnuidade }])
                }
            }
        }

        loadValores()
    }, [])

    useEffect(() => {
        async function loadAspirante() {
            const storedData = JSON.parse(localStorage.getItem('sindmepa-associacao-temp-data'))

            const aspirante = await api.get('associado', {
                params: {
                    cpf: storedData.pessoal.cpf,
                    aspirante: 1,
                    medico: 0
                }
            })

            const mensalidade = await api.get(`mensalidade_valor/${new Date().getFullYear()}`)

            if (aspirante) {
                if (new Date() > new Date(getYear(new Date()), 5, 30)) {
                    const valorMensalidadeProporcional = mensalidade.valor
                    const { valorAnuidadeProporcional, competenciaAno } = await calculaAnuidadeProporcional(valorMensalidadeProporcional)
                    setValorAspirante(maskUtils.maskApply.currency(valorAnuidadeProporcional / 2))
                    setAno(competenciaAno)
                } else {
                    const valoresDesconto = await api.get('desconto_anuidade', {
                        params: {
                            grupo: 'aspirante'
                        }
                    })

                    setValorAspirante(maskUtils.maskApply.currency(valoresDesconto.valor))
                }
            }
        }

        loadAspirante()
    }, [])

    if (!valoresAnuidade && !valorAspirante) {
        return <Spinner />
    }

    return (
        <>
            <Container>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validation}
                    onSubmit={onSubmit}
                    enableReinitialize
                >
                    {({ isSubmitting, setFieldValue }) => (
                        <Form>
                            <>
                                <p style={{ margin: '24px 8px 0', textDecoration: valorAspirante ? 'line-through' : 'unset' }}>
                                    Valor da anuidade:
                                    <span style={{ fontWeight: 800 }}>
                                        {valoresAnuidade.length && valoresAnuidade[0].valor > 0 ? ` ${maskUtils.maskApply.currency(valoresAnuidade[0].valor)}` : ' -'}
                                    </span>
                                </p>

                                {valorAspirante && (
                                    <p>
                                        Valor com desconto para ex-acadêmicos aspirantes (válido nos 2 primeiros anos):
                                        <span style={{ fontWeight: 800 }}>
                                            {` ${valorAspirante}`}
                                        </span>
                                    </p>
                                )}
                            </>

                            <TermoContainer>
                                <Button onClick={() => setShowTermoCiencia(true)} className="transparent">
                                    VER TERMO DE CIÊNCIA
                                </Button>
                            </TermoContainer>

                            <Checkbox
                                name="autorizado"
                                label={`Li e concordo com o Termo de Ciência acima e autorizo a emissão do boleto da anuidade de ${ano}, no valor correspondente a ${valorAspirante || maskUtils.maskApply.currency(valoresAnuidade[0]?.valor)}, em favor do Sindicato dos Médicos do Pará. Estou ciente que este valor será reajustado anualmente no mês de janeiro.`}
                                handleChange={e => { setFieldValue(e.target.name, e.target.checked) }}
                                containerStyle={{ gridArea: 'check' }}
                            />

                            <ActionFooter style={{ gridArea: 'button' }}>
                                <Button type="submit" loading={isSubmitting} className="white">
                                    Concluir
                                    <FaCheck />
                                </Button>
                            </ActionFooter>
                        </Form>
                    )}
                </Formik>
            </Container>

            <Modal
                isOpen={showTermoCiencia}
                handleClose={() => setShowTermoCiencia(false)}
                title="Termo de Ciência do Associado"
            >
                <ModalTermoContainer>
                    <iframe src={`${process.env.REACT_APP_BACKEND_URL}/resources/TERMO DE CIENCIA SINDMEPA.pdf`} frameBorder="0" title="Termo de Ciência" />
                </ModalTermoContainer>
            </Modal>
        </>
    )
}
